import React from 'react';
import Modal from 'react-modal';
import { PropTypes } from 'prop-types';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import colors from '@general/colors';
import { isScreenMinMd, useScreenSmDown } from '@hooks/useResponsive';

Modal.setAppElement('body');

export const MODAL_STANDARD_BODY_STYLES = {
    paddingBottom: '64px',
    paddingLeft: '64px',
    paddingRight: '64px',
    paddingTop: '24px',
};

const ModalBase = ({
    children,
    isOpen,
    shouldCloseOnOverlayClick = true,
    showCloseButton = true,
    stylesBody = {},
    stylesContent = {},
    stylesOverlay = {},
    onClose,
}) => {
    const isScreenSmDown = useScreenSmDown();

    // not sure why this is necessary to stop the page from scrolling
    const onAfterOpen = () => {
        const htmlEl = document.getElementsByTagName('html')[0];
        htmlEl.classList.add('ReactModal__HTML--open');
    };
    const onAfterClose = () => {
        const htmlEl = document.getElementsByTagName('html')[0];
        htmlEl.classList.remove('ReactModal__HTML--open');
    };

    const closeModal = () => {
        onClose();
    };

    const contentStyles = {
        ...modalStyles.content,
        ...stylesContent,
    };

    if (isScreenSmDown) {
        contentStyles.borderTopWidth = 0;
        contentStyles.height = '100%';
        contentStyles.width = '100%';
    }

    return (
        <Modal
            isOpen={isOpen}
            style={{
                overlay: {
                    ...modalStyles.overlay,
                    ...stylesOverlay,
                },
                content: contentStyles,
            }}
            closeTimeoutMS={300}
            onAfterOpen={onAfterOpen}
            onAfterClose={onAfterClose}
            onRequestClose={closeModal}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        >
            {showCloseButton && (
                <div className="d-flex justify-content-end">
                    <button
                        type="button"
                        className="close d-flex align-items-center"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={closeModal}
                        style={modalStyles.close}
                    >
                        Close{' '}
                        <span style={{ fontSize: '12px' }}>
                            <FontAwesomeIcon
                                style={{ marginLeft: '10px' }}
                                icon={faTimes}
                                color="#000"
                                size="lg"
                                className="cursor-pointer"
                            />
                        </span>
                    </button>
                </div>
            )}

            <div
                className="ReactModal__Body"
                style={{
                    ...modalStyles.body,
                    ...stylesBody,
                }}
            >
                {children}
            </div>
        </Modal>
    );
};

const modalStyles = {
    overlay: {
        zIndex: 99999,
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        overflowX: 'hidden',
        overflowY: 'auto',
        padding: isScreenMinMd() ? '3% 0.5rem 3% 0.5rem' : 0,
        backgroundColor: 'rgba(52, 52, 52, .80)',
    },
    content: {
        borderBottom: 'none',
        borderLeft: 'none',
        borderRadius: 0,
        borderRight: 'none',
        borderTopColor: colors.primary,
        borderTopStyle: 'solid',
        borderTopWidth: 6,
        bottom: 'auto',
        left: 'auto',
        margin: '0 auto',
        maxWidth: '500px',
        overflow: 'visible',
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        position: 'relative',
        right: 'auto',
        top: 'auto',
    },
    body: {
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
    },
    close: {
        color: '#000',
        fontSize: '12px',
        textTransform: 'uppercase',
        fontFamily: 'Red Hat Display',
        fontWeight: 700,
        marginTop: '24px',
        marginRight: '24px',
    },
};

ModalBase.propTypes = {
    children: PropTypes.node,
    isOpen: PropTypes.bool.isRequired,
    shouldCloseOnOverlayClick: PropTypes.bool,
    showCloseButton: PropTypes.bool,
    stylesBody: PropTypes.object,
    stylesContent: PropTypes.object,
    stylesOverlay: PropTypes.object,
    onClose: PropTypes.func,
};

export default ModalBase;
